const BOBS_BURGERS_DESCRIPTION =
  "The Bob's Burgers API is a REST API based on the television show Bob's Burgers. The Bob's Burgers API contains data for hundreds of characters, episodes, running gags and images from the show.";

const SECRET_SANTA_DESCRIPTION =
  "Secret Santa Generator is a free online Secret Santa gift exchange generator to easily create a Secret Santa list to share with friends and family.";

const VISUALIZING_ANTARCTICA_DESCRIPTION =
  "A tool for navigating and displaying multi-banded GeoTIFF image data from Antarctic satellite survey photography onto an interactive Leaflet map.";

const RESEARCH_PLUGIN_DESCRIPTION =
  "Chrome extension to add tooltips on GitHub pages when creating pull requests, or creating an issue repoort in any repository to help newcomers contribute to open source projects.";

export {
  BOBS_BURGERS_DESCRIPTION,
  SECRET_SANTA_DESCRIPTION,
  VISUALIZING_ANTARCTICA_DESCRIPTION,
  RESEARCH_PLUGIN_DESCRIPTION,
};
